import { createContext } from "react";

import { Client, Conversation, Message, Paginator } from "@twilio/conversations";

export interface ConversationContextProps {
  client: Client | null;
  conversation: Conversation | null;
  messages: Paginator<Message> | null;
  handleSendMessage: (message: string) => void;
  handleSendMediaMessage: (media: File) => void;
  getPrevPage: () => void;
  isFetchingPrevPage: boolean;
  identity: string | null;
  handleReadMessages: () => void;
  unreadMessagesCount: number;
}

export const ConversationContext = createContext<ConversationContextProps | undefined>(
  undefined
);
